const squares = `<div id="squares">
                    <div id="goldSquare"></div>
                    <div id="tomatoSquare"></div>
                    <div id="blueSquare"></div>
                </div>`;

export default squares;